// extracted by mini-css-extract-plugin
export default {"container":"PatientContact_container__ZKlB5","title":"PatientContact_title__8JN4F"};